// extracted by mini-css-extract-plugin
export default {"modal":"TemplateShareModal_modal__NjuMa"};